import { render, staticRenderFns } from "./PolicyDetachModal.vue?vue&type=template&id=a6b88d8a&scoped=true"
import script from "./PolicyDetachModal.vue?vue&type=script&lang=js"
export * from "./PolicyDetachModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetachModal.vue?vue&type=style&index=0&id=a6b88d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b88d8a",
  null
  
)

export default component.exports